import React, { useState, Fragment } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import FilterModal from 'src/Admin/components/common/filter-modal/FilterModal';
import MultipleFileUpload from 'src/Components/fileupload/MultipleFileUpload';
import FileInfo from 'src/Components/fileupload/FileInfo';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { arrayBufferToBase64 } from 'src/Admin/utils/common';
import { axiosInstance } from 'src/api/axios';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import { toast } from 'react-toastify';
import ToastMessage from 'src/Admin/components/common/ToastMessage';
import moment from 'moment';
import { useSelector } from 'react-redux';

const DocumentBox = ({
  documentKey,
  documentName,
  oid,
  documentOid,
  documentFor,
  documentTitle,
  updatedDate,
  updatedBy,
  documentDescription,
  viewPermission = false, //Later will be using this while implementing based on permissions
  editPermission = false, //Later will be using this while implementing based on permissions
  awaitInitialUpload = false,
  getAllHelpDoc,
}) => {
  const DownloadDocumentIcon = () => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#00205C" fillOpacity="0.1" />
      <path
        d="M23.2002 17.4004C23.7523 17.4006 24.2002 17.8482 24.2002 18.4004V21.6006C24.2 22.2898 23.9257 22.951 23.4385 23.4385C22.9509 23.9259 22.2891 24.2002 21.5996 24.2002H10.3994C9.71008 24.2001 9.04901 23.9259 8.56152 23.4385C8.07413 22.951 7.79996 22.2899 7.7998 21.6006V18.4004C7.7998 17.8481 8.24752 17.4004 8.7998 17.4004C9.35209 17.4004 9.7998 17.8481 9.7998 18.4004V21.6006C9.79996 21.7595 9.86326 21.912 9.97559 22.0244C10.088 22.1367 10.2405 22.2001 10.3994 22.2002H21.5996C21.7586 22.2002 21.9119 22.1368 22.0244 22.0244C22.1366 21.9121 22.2 21.7594 22.2002 21.6006V18.4004C22.2002 17.8481 22.6479 17.4004 23.2002 17.4004ZM16 7.7998C16.5522 7.7998 16.9999 8.24761 17 8.7998V15.9863L19.293 13.6934C19.6835 13.3028 20.3165 13.3028 20.707 13.6934C21.0974 14.0839 21.0975 14.717 20.707 15.1074L16.707 19.1074C16.6485 19.1659 16.5834 19.2139 16.5156 19.2549C16.4734 19.2804 16.4298 19.3041 16.3838 19.3232C16.3639 19.3315 16.3435 19.3378 16.3232 19.3447C16.3128 19.3483 16.3026 19.3522 16.292 19.3555C16.1015 19.4135 15.8975 19.4137 15.707 19.3555C15.6965 19.3522 15.6862 19.3483 15.6758 19.3447C15.6556 19.3378 15.6351 19.3315 15.6152 19.3232C15.5692 19.3041 15.5256 19.2804 15.4834 19.2549C15.4159 19.214 15.3513 19.1657 15.293 19.1074L11.293 15.1074C10.9025 14.717 10.9026 14.0839 11.293 13.6934C11.6835 13.3028 12.3165 13.3028 12.707 13.6934L15 15.9863V8.7998C15.0001 8.24761 15.4478 7.7998 16 7.7998Z"
        fill="#00205C"
      />
    </svg>
  );
  const EditDocumentIcon = () => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#00205C" fillOpacity="0.1" />
      <path
        d="M16 9.25H10.75C10.3522 9.25 9.97064 9.40804 9.68934 9.68934C9.40804 9.97064 9.25 10.3522 9.25 10.75V21.25C9.25 21.6478 9.40804 22.0294 9.68934 22.3107C9.97064 22.592 10.3522 22.75 10.75 22.75H21.25C21.6478 22.75 22.0294 22.592 22.3107 22.3107C22.592 22.0294 22.75 21.6478 22.75 21.25V16"
        stroke="#00205C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7813 8.9688C21.0797 8.67043 21.4844 8.50281 21.9063 8.50281C22.3283 8.50281 22.733 8.67043 23.0313 8.9688C23.3297 9.26717 23.4973 9.67184 23.4973 10.0938C23.4973 10.5158 23.3297 10.9204 23.0313 11.2188L16.2716 17.9793C16.0935 18.1572 15.8735 18.2875 15.6318 18.358L13.4771 18.988C13.4125 19.0069 13.3441 19.008 13.279 18.9913C13.2139 18.9746 13.1544 18.9407 13.1069 18.8932C13.0594 18.8457 13.0255 18.7862 13.0088 18.7211C12.9921 18.656 12.9932 18.5876 13.0121 18.523L13.6421 16.3683C13.713 16.1268 13.8435 15.9071 14.0216 15.7293L20.7813 8.9688Z"
        stroke="#00205C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const { Default_Time_Format } = useSelector(
    ({ app }) => app.appConfigs.Time_Setting || 'MM-dd-yyyy',
  );

  const [showEditModal, setShowEditModal] = useState(false);
  const [editDocumentTitle, setEditDocumentTitle] = useState(documentTitle);
  const [editDocumentDescription, setEditDocumentDecription] =
    useState(documentDescription);
  const [isUploadFilePopup, setIsUploadFilePopup] = useState(false);
  const [files, setFiles] = useState([]);
  const [apiUploadError, setApiUploadError] = useState(false);
  const [filesLoader, setfilesLoader] = useState(false);
  const [fileUploadStatus, setFileUploadStatus] = useState('pending');
  const [fileProgress, setFileProgress] = useState(0);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false);
  const [isUploadButtonDisabled, setIsUploadButtonDisabled] = useState(false);

  const handleDocumentTitleChange = (e) => {
    setEditDocumentTitle(e.target.value);
  };

  const handleDocumentDescriptionChange = (e) => {
    setEditDocumentDecription(e.target.value);
  };

  const applyEditModalFilterHandler = () => {
    const payload = {
      oid: oid,
      keydesc: editDocumentDescription,
      document_title: editDocumentTitle,
    };
    setIsSaveButtonDisabled(true);
    updateHelpCenterDocuments(payload, 'editRequest');
  };

  const applyUploadFileFilterHandler = async () => {
    console.log('files uplaoded', files);
    setIsUploadButtonDisabled(true);
    initiateFileUpload();
  };

  const initiateFileUpload = () => {
    setfilesLoader(true);
    const uploadPromises = files.map((fileItem, index) => {
      if (fileItem.uploadStatus !== 'uploaded') {
        return uploadFiles(fileItem, index);
      }
      return;
    });
    Promise.all(uploadPromises)
      .then((res) => {
        console.log('res', res);
        setFileUploadStatus('uploaded');
        setfilesLoader(false);
      })
      .catch(() => {
        setFileUploadStatus('failed');
        setfilesLoader(false);
      });
  };

  const uploadFiles = async (fileItem, index) => {
    let percent = 0;
    const config = {
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        percent = Math.floor((loaded * 100) / total);
        if (percent <= 100) {
          setFileProgress(percent);
          setFiles((current) =>
            current.map((obj, i) => {
              if (i === index) {
                return { ...obj, uploadPercent: percent };
              }
              return obj;
            }),
          );
        }
      },
    };
    return axiosInstance
      .post(
        APIEndpoints.postDocumentResource() +
          `fileuri/${fileItem?.file?.name?.split('.')[0]}/description/
              ${fileItem?.file?.name}`,
        fileItem?.file,
        config,
      )
      .then((res) => {
        setFiles((current) =>
          current.map((obj, i) => {
            if (i === index) {
              return { ...obj, uploadStatus: 'uploaded', ...res.data.Response };
            }
            return obj;
          }),
        );
        setApiUploadError(false);
        const payload = {
          oid: oid,
          value: res.data.Response.Oid,
          document_name: fileItem?.file?.name,
        };
        updateHelpCenterDocuments(payload, 'uploadRequest');
        return res;
      })
      .catch((err) => {
        setFiles((current) =>
          current.map((obj, i) => {
            if (i === index) {
              return { ...obj, uploadStatus: 'failed' };
            }
            return obj;
          }),
        );
        setApiUploadError(true);
        toast.error(
          <ToastMessage
            type="error"
            subTitle={'File Uploaded Unsuccessfully'}
          />,
        );
        setIsUploadButtonDisabled(false);
        return Promise.reject(err);
      });
  };

  const updateHelpCenterDocuments = async (payload, requestType) => {
    try {
      const response = await axiosInstance.put(
        APIEndpoints.updateHelpCenterDocuments(),
        payload,
      );

      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle={
              requestType === 'uploadRequest'
                ? 'File Uploaded Successfully'
                : 'Updated Successfully'
            }
          />,
        );
        if (requestType === 'uploadRequest') {
          setIsUploadFilePopup(false);
          setIsUploadButtonDisabled(false);
        } else {
          setShowEditModal(false);
          setIsSaveButtonDisabled(false);
        }
        getAllHelpDoc();
      }
    } catch (error) {
      console.log('error------->>>>', error);
      toast.error(
        <ToastMessage
          type="error"
          subTitle={
            requestType === 'uploadRequest'
              ? 'Something went wrong with request. File is not uploaded successfully'
              : 'Something went wrong with request. Failed to Edit Title and Description'
          }
        />,
      );
      requestType === 'uploadRequest'
        ? setIsUploadButtonDisabled(false)
        : setIsSaveButtonDisabled(false);
    }
  };

  const getFileName = (fileName = '') => {
    const index = fileName.lastIndexOf('.');
    return index !== -1 ? fileName.slice(0, index) : fileName;
  };

  const downloadFile = async (oid, fileName, extension) => {
    try {
      const documentData = await axiosInstance.get(
        `${APIEndpoints.getDocument() + oid}`,
        { responseType: 'arraybuffer' },
      );

      const contentType = documentData.headers['content-type'];
      fileName = fileName ? fileName : 'download';

      const link = document.createElement('a');
      const actualData = arrayBufferToBase64(documentData.data);

      link.style.visibility = 'hidden';
      link.setAttribute('download', fileName + extension);
      link.setAttribute(
        'href',
        'data:' + contentType + ';base64,' + actualData,
      );

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      toast.success(
        <ToastMessage
          type="success"
          subTitle={'File Downloaded Successfully'}
        />,
      );
    } catch (error) {
      console.log(error);

      toast.error(
        <ToastMessage
          type="error"
          subTitle={'File Downloaded Unsuccessfully'}
        />,
      );
    }
  };
  return (
    <>
      <Col className="box-margin" md={4}>
        <div className="documents-box">
          <div className="box-header">
            <div className={documentFor && 'document-for'}>{documentFor}</div>
            <div>
              {!awaitInitialUpload && (
                <span
                  className="icon-space download-doc"
                  onClick={() => {
                    downloadFile(
                      documentOid,
                      getFileName(documentName) || documentKey,
                      '.pdf',
                    );
                  }}
                >
                  <DownloadDocumentIcon />
                </span>
              )}
              <span
                className="edit-icon"
                onClick={() => {
                  setShowEditModal(true);
                  setEditDocumentTitle(documentTitle);
                  setEditDocumentDecription(documentDescription);
                }}
              >
                <EditDocumentIcon />
              </span>
            </div>
          </div>
          <div className="box-body">
            <div className="document-title">{documentTitle}</div>
            <div
              className={`document-updated ${
                awaitInitialUpload && 'await-upload'
              }`}
            >
              {awaitInitialUpload
                ? 'Awaiting Initial Upload'
                : `Last Updated: ${
                    updatedDate
                      ? moment(updatedDate).format(Default_Time_Format)
                      : 'NA'
                  } by ${updatedBy || 'NA'}`}
            </div>
            <div className="document-description">{documentDescription}</div>
            <div className="upload-div">
              <GenericButton
                className="pl-0 upload-btn"
                variant="link"
                onClick={() => {
                  setIsUploadFilePopup(true);
                  setFiles([]);
                  setfilesLoader(false);
                }}
              >
                {awaitInitialUpload
                  ? 'Upload Initial Document'
                  : 'Upload New Version'}
              </GenericButton>
            </div>
          </div>
        </div>
      </Col>
      <FilterModal
        customClasses="edit-document-details-modal"
        showBackButton={false}
        isVisible={showEditModal}
        onHide={() => {
          setShowEditModal(false);
        }}
        applyFilterHandler={applyEditModalFilterHandler}
        showCancel={true}
        titleLabel="Edit Details"
        showApply={true}
        showApplyLabel="SAVE CHANGES"
        showCancelLabel="Close"
        isDisabled={
          !editDocumentTitle.length ||
          !editDocumentDescription.length ||
          isSaveButtonDisabled
        }
        postLabel="SAVE CHANGES"
      >
        <Container className="mt-3 mb-3">
          <Row>
            <Col sm={12} className="edit-modal-info-text">
              Add a completely new document entity to the help section
            </Col>
          </Row>
          <Row className="mt-3">
            <Col sm={12}>
              <Form.Group controlId="formDocumentTitle">
                <Form.Label>
                  Document Title <span className="form-required">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="documenttitle"
                  placeholder=""
                  className=""
                  maxLength={50}
                  value={editDocumentTitle}
                  onChange={(e) => handleDocumentTitleChange(e)}
                  autoCorrect="off"
                  spellCheck="off"
                  autoFocus={false}
                  autoComplete="off"
                  isInvalid={!editDocumentTitle.length}
                />
                {!editDocumentTitle.length && (
                  <Form.Control.Feedback type="invalid">
                    <span role="alert">Enter Document Title</span>
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col sm={12}>
              <Form.Group controlId="formDescription">
                <Form.Label>
                  Description <span className="form-required">*</span>
                </Form.Label>
                <Form.Control
                  rows={4}
                  as="textarea"
                  name="documentdescription"
                  placeholder=""
                  className=""
                  value={editDocumentDescription}
                  onChange={(e) => handleDocumentDescriptionChange(e)}
                  autoCorrect="off"
                  maxLength={200}
                  spellCheck="off"
                  autoFocus={false}
                  autoComplete="off"
                  isInvalid={!editDocumentDescription.length}
                />
                {!editDocumentDescription.length && (
                  <Form.Control.Feedback type="invalid">
                    <span role="alert">Enter Document Description</span>
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Container>
      </FilterModal>
      <FilterModal
        customClasses="upload-help-document-modal"
        showBackButton={false}
        isVisible={isUploadFilePopup}
        onHide={() => {
          setIsUploadFilePopup(false);
          setFileUploadStatus('pending');
        }}
        applyFilterHandler={applyUploadFileFilterHandler}
        showCancel={true}
        titleLabel={
          awaitInitialUpload ? 'Upload Initial Document' : 'Upload New Version'
        }
        showApply={true}
        showApplyLabel="UPLOAD"
        showCancelLabel="Close"
        isDisabled={files.length === 0 || isUploadButtonDisabled}
        postLabel="UPLOAD"
      >
        <Container>
          <div className="mt-3 upload-info-text">Updating: {documentTitle}</div>
          <div className="mt-3 upload-title-text">Upload Document</div>
          {!files.length && (
            <div className="mt-3">
              <MultipleFileUpload
                files={files}
                setFiles={setFiles}
                name="file"
                fileType={['.pdf']}
                fileSize={Infinity}
                className={''}
                showFileTypeMessage={false}
                isMultiSelect={false}
                setFieldValue={(e) => console.log('e :', e)}
              />
            </div>
          )}
          <div className="mt-3  help-documents-files-container">
            {files &&
              files.map((item, index) => {
                return (
                  <Fragment key={index}>
                    <FileInfo
                      files={files}
                      setFiles={setFiles}
                      fileDetails={item}
                      //filesLoader={false}
                      readFileSize={true}
                      apiUploadError={apiUploadError}
                      filesLoader={filesLoader}
                      fileUploadStatus={item?.uploadStatus}
                      fileProgress={item?.uploadPercent}
                      setFieldValue={(e) => console.log('e :', e)}
                    />
                    {apiUploadError && (
                      <div className="files-error-text">
                        {`We couldn't process that file.`}
                      </div>
                    )}
                  </Fragment>
                );
              })}
          </div>
        </Container>
      </FilterModal>
    </>
  );
};

export default DocumentBox;
